import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import * as i3 from 'bulk-upload-dashboard';
import * as i4 from 'custom-button-action';
import * as i5 from 'ngx-toastr';
import * as i6 from 'cache-country-list';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';

class SupplierEditDetailsService {
    constructor(http) {
        this.http = http;
    }
    editDocument(errorId) {
        return this.http.get('/vd/formBuilder/get/supplier/' + errorId + '/info').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    editErrorDocument(errorId) {
        return this.http.get('/vd/formBuilder/supplier/bulkupload/supplier/' + errorId + '/details').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
}
SupplierEditDetailsService.ɵfac = function SupplierEditDetailsService_Factory(t) { return new (t || SupplierEditDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
SupplierEditDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierEditDetailsService, factory: SupplierEditDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupplierEditDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function SupplierEditDetailsComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " Supplier Name is Required ");
    i0.ɵɵelementEnd();
} }
function SupplierEditDetailsComponent_option_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r7 = ctx.$implicit;
    i0.ɵɵproperty("value", data_r7.phoneCode);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", data_r7.countryName, " - ", data_r7.phoneCode, " ");
} }
function SupplierEditDetailsComponent_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " Please enter a valid phone number ");
    i0.ɵɵelementEnd();
} }
function SupplierEditDetailsComponent_span_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " Email is required ");
    i0.ɵɵelementEnd();
} }
function SupplierEditDetailsComponent_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " Please enter a valid email address ");
    i0.ɵɵelementEnd();
} }
function SupplierEditDetailsComponent_span_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, " Please enter a valid Location ");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "im-input-error": a0 }; };
const _c1 = function (a0) { return { "invalidBtn": a0 }; };
class SupplierEditDetailsComponent {
    constructor(fb, supplierEditDetailsService, bulkUploadDashboardService, customButtonActionService, toastr, cc, ch) {
        this.fb = fb;
        this.supplierEditDetailsService = supplierEditDetailsService;
        this.bulkUploadDashboardService = bulkUploadDashboardService;
        this.customButtonActionService = customButtonActionService;
        this.toastr = toastr;
        this.cc = cc;
        this.ch = ch;
        this.getSupplierDetails = {};
        this.subscription = [];
        this.observableSubscription$ = new Subject();
        this.submitted = false;
    }
    ngOnInit() {
        this.supplierDetailsForm = this.fb.group({
            supplierName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+( [a-zA-Z]+)*$')]],
            phoneNumber: ['', [Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\.0-9]*$')]],
            phoneCode: [''],
            communicationEmailId: ['', [Validators.required, Validators.email]],
            location: ['', [Validators.pattern('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$')]]
        });
        const isErrorEdit = sessionStorage.getItem('isErrorEdit') === 'true';
        if (isErrorEdit) {
            this.getEditId = this.bulkUploadDashboardService.getErrorId;
            this.subscription[this.subscription.length] = this.supplierEditDetailsService.editErrorDocument(this.getEditId).subscribe((response) => {
                if (response.data) {
                    this.getSupplierDetails = response.data;
                    this.getParsingDetails();
                }
            });
        }
        else {
            this.getEditId = sessionStorage.getItem('idToGetDetails');
            this.subscription[this.subscription.length] = this.supplierEditDetailsService.editDocument(this.getEditId).subscribe((response) => {
                if (response.data) {
                    this.getSupplierDetails = response.data;
                    this.getParsingDetails();
                }
            });
        }
        this.cc.getCountry().subscribe((data) => {
            this.DataArr = data;
            this.ch.detectChanges();
        });
        this.companyId = parseInt(sessionStorage.getItem("companyId"));
    }
    saveSupplierData() {
        const payload = Object.assign(Object.assign({}, this.supplierDetailsForm.value), { supplierDetailsFrom: "SAVE_UPDATE_SUPPLIER_MANUALLY", id: Number(this.getEditId), isDel: false, companyId: this.companyId });
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.addSupplier(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                console.log(response);
                this.toastr.success(response.message, 'Success');
                const item = {
                    formType: 1481,
                    pageFormId: 384
                };
                this.customButtonActionService.onLinkRedirectPageSubject.next(item);
            }
        });
    }
    getParsingDetails() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.supplierDetailsForm.get('supplierName').setValue(((_a = this.getSupplierDetails) === null || _a === void 0 ? void 0 : _a.supplierName) ? (_b = this.getSupplierDetails) === null || _b === void 0 ? void 0 : _b.supplierName : "");
        this.supplierDetailsForm.get('phoneNumber').setValue(((_c = this.getSupplierDetails) === null || _c === void 0 ? void 0 : _c.phoneNumber) ? (_d = this.getSupplierDetails) === null || _d === void 0 ? void 0 : _d.phoneNumber : "");
        // this.supplierDetailsForm.get('phoneCode').setValue(this.getSupplierDetails?.phoneCode? this.getSupplierDetails?.phoneCode : "");
        let phoneCode = ((_e = this.getSupplierDetails) === null || _e === void 0 ? void 0 : _e.phoneCode) ? (_f = this.getSupplierDetails) === null || _f === void 0 ? void 0 : _f.phoneCode : "";
        if (phoneCode.startsWith("+")) {
            phoneCode = phoneCode.substring(1);
        }
        this.supplierDetailsForm.get('phoneCode').setValue(phoneCode);
        this.supplierDetailsForm.get('communicationEmailId').setValue(((_g = this.getSupplierDetails) === null || _g === void 0 ? void 0 : _g.communicationEmailId) ? (_h = this.getSupplierDetails) === null || _h === void 0 ? void 0 : _h.communicationEmailId : "");
        this.supplierDetailsForm.get('location').setValue(((_j = this.getSupplierDetails) === null || _j === void 0 ? void 0 : _j.location) ? (_k = this.getSupplierDetails) === null || _k === void 0 ? void 0 : _k.location : "");
    }
    valueChange(e) {
        this.selected = e.target.value;
    }
}
SupplierEditDetailsComponent.ɵfac = function SupplierEditDetailsComponent_Factory(t) { return new (t || SupplierEditDetailsComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(SupplierEditDetailsService), i0.ɵɵdirectiveInject(i3.BulkUploadDashboardService), i0.ɵɵdirectiveInject(i4.CustomButtonActionService), i0.ɵɵdirectiveInject(i5.ToastrService), i0.ɵɵdirectiveInject(i6.CacheCountryListService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SupplierEditDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupplierEditDetailsComponent, selectors: [["lib-supplier-edit-details"]], decls: 37, vars: 23, consts: [[3, "formGroup", "ngSubmit"], ["f", "ngForm"], [1, "row", "mt-2"], [1, "col-4"], [1, "label-cls", "text-label", "details-label"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "supplierName", "placeholder", "Enter your supplier Name", 1, "im-input", 3, "ngClass"], ["class", "invalid-message", 4, "ngIf"], [1, "label-cls", "dd-label"], ["formControlName", "phoneCode", 1, "form-control", "mt-2", 2, "width", "102%", "margin-left", "3px", 3, "change"], [3, "value", 4, "ngFor", "ngForOf"], ["type", "text", "formControlName", "phoneNumber", "pattern", "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$", 1, "im-input", 3, "ngClass"], ["type", "text", "formControlName", "communicationEmailId", "pattern", "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$", 1, "im-input", 3, "ngClass"], ["type", "text", "formControlName", "location", 1, "im-input", 3, "ngClass"], ["type", "submit", 1, "btn", "btn-success", "save-btn", 3, "disabled", "ngClass"], [1, "invalid-message"], [3, "value"]], template: function SupplierEditDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0, 1);
        i0.ɵɵlistener("ngSubmit", function SupplierEditDetailsComponent_Template_form_ngSubmit_0_listener() { return ctx.saveSupplierData(); });
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "p", 4);
        i0.ɵɵtext(5, "Supplier Name");
        i0.ɵɵelementStart(6, "sup");
        i0.ɵɵtext(7, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "input", 5);
        i0.ɵɵtemplate(9, SupplierEditDetailsComponent_span_9_Template, 2, 0, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 2);
        i0.ɵɵelementStart(11, "div", 3);
        i0.ɵɵelementStart(12, "p", 7);
        i0.ɵɵtext(13, "Phone Code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "select", 8);
        i0.ɵɵlistener("change", function SupplierEditDetailsComponent_Template_select_change_14_listener($event) { return ctx.valueChange($event); });
        i0.ɵɵtemplate(15, SupplierEditDetailsComponent_option_15_Template, 2, 3, "option", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 3);
        i0.ɵɵelementStart(17, "p", 4);
        i0.ɵɵtext(18, "Daytime telephone no.");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "input", 10);
        i0.ɵɵtemplate(20, SupplierEditDetailsComponent_span_20_Template, 2, 0, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 3);
        i0.ɵɵelementStart(22, "p", 4);
        i0.ɵɵtext(23, "Email");
        i0.ɵɵelementStart(24, "sup");
        i0.ɵɵtext(25, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(26, "input", 11);
        i0.ɵɵtemplate(27, SupplierEditDetailsComponent_span_27_Template, 2, 0, "span", 6);
        i0.ɵɵtemplate(28, SupplierEditDetailsComponent_span_28_Template, 2, 0, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 2);
        i0.ɵɵelementStart(30, "div", 3);
        i0.ɵɵelementStart(31, "p", 4);
        i0.ɵɵtext(32, "Location");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(33, "input", 12);
        i0.ɵɵtemplate(34, SupplierEditDetailsComponent_span_34_Template, 2, 0, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "button", 13);
        i0.ɵɵtext(36, " Save ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.supplierDetailsForm);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0, ctx.supplierDetailsForm.get("supplierName").touched && (ctx.supplierDetailsForm.get("supplierName").errors == null ? null : ctx.supplierDetailsForm.get("supplierName").errors.required)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.supplierDetailsForm.get("supplierName").touched || ctx.submitted) && (ctx.supplierDetailsForm.get("supplierName").errors == null ? null : ctx.supplierDetailsForm.get("supplierName").errors.required));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.DataArr);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0, (ctx.supplierDetailsForm.get("phoneNumber").touched || ctx.submitted) && ((ctx.supplierDetailsForm.get("phoneNumber").errors == null ? null : ctx.supplierDetailsForm.get("phoneNumber").errors.required) || (ctx.supplierDetailsForm.get("phoneNumber").errors == null ? null : ctx.supplierDetailsForm.get("phoneNumber").errors.pattern))));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.supplierDetailsForm.get("phoneNumber").touched || ctx.submitted) && (ctx.supplierDetailsForm.get("phoneNumber").errors == null ? null : ctx.supplierDetailsForm.get("phoneNumber").errors.pattern));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c0, (ctx.supplierDetailsForm.get("communicationEmailId").touched || ctx.submitted) && ((ctx.supplierDetailsForm.get("communicationEmailId").errors == null ? null : ctx.supplierDetailsForm.get("communicationEmailId").errors.required) || (ctx.supplierDetailsForm.get("communicationEmailId").errors == null ? null : ctx.supplierDetailsForm.get("communicationEmailId").errors.email))));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.supplierDetailsForm.get("communicationEmailId").touched || ctx.submitted) && (ctx.supplierDetailsForm.get("communicationEmailId").errors == null ? null : ctx.supplierDetailsForm.get("communicationEmailId").errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.supplierDetailsForm.get("communicationEmailId").touched || ctx.submitted) && (ctx.supplierDetailsForm.get("communicationEmailId").errors == null ? null : ctx.supplierDetailsForm.get("communicationEmailId").errors.email));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c0, ctx.supplierDetailsForm.get("location").touched && (ctx.supplierDetailsForm.get("location").errors == null ? null : ctx.supplierDetailsForm.get("location").errors.required)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.supplierDetailsForm.get("location").touched || ctx.submitted) && (ctx.supplierDetailsForm.get("location").errors == null ? null : ctx.supplierDetailsForm.get("location").errors.pattern));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.supplierDetailsForm.invalid)("ngClass", i0.ɵɵpureFunction1(21, _c1, ctx.supplierDetailsForm.invalid));
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.DefaultValueAccessor, i1$1.PatternValidator, i1$1.NgControlStatus, i1$1.FormControlName, i7.NgClass, i7.NgIf, i1$1.SelectControlValueAccessor, i7.NgForOf, i1$1.NgSelectOption, i1$1.ɵangular_packages_forms_forms_z], styles: [".save-btn[_ngcontent-%COMP%]{position:relative;top:32px;left:22px}sup[_ngcontent-%COMP%]{color:#c54545}.text-label[_ngcontent-%COMP%]{margin-left:5px;color:#000!important}.dd-label[_ngcontent-%COMP%]{margin-left:2px;color:#000!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupplierEditDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-supplier-edit-details',
                templateUrl: 'supplier-edit-details.component.html',
                styleUrls: ['supplier-edit-details.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: SupplierEditDetailsService }, { type: i3.BulkUploadDashboardService }, { type: i4.CustomButtonActionService }, { type: i5.ToastrService }, { type: i6.CacheCountryListService }, { type: i0.ChangeDetectorRef }]; }, null); })();

class SupplierEditDetailsModule {
}
SupplierEditDetailsModule.ɵfac = function SupplierEditDetailsModule_Factory(t) { return new (t || SupplierEditDetailsModule)(); };
SupplierEditDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierEditDetailsModule });
SupplierEditDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierEditDetailsModule, { declarations: [SupplierEditDetailsComponent], imports: [CommonModule,
        ReactiveFormsModule], exports: [SupplierEditDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupplierEditDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [SupplierEditDetailsComponent],
                imports: [
                    CommonModule,
                    ReactiveFormsModule
                ],
                exports: [SupplierEditDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of supplier-edit-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SupplierEditDetailsComponent, SupplierEditDetailsModule, SupplierEditDetailsService };
//# sourceMappingURL=supplier-edit-details.js.map
